import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { RoomBookingData, RoomPhoneData } from '../../Redux/action/roomAction';
import { onBuildingLocation1 } from '../../Redux/action/memberAction';
import { LocationFilterAction } from '../../Redux/action/seatAction';
import { dataUser, dataLocation } from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import {
  CityFilterAction,
  buildingFilterAction,
} from '../../Redux/action/roomTraingAction';
import { endsWith, property, startCase } from 'lodash';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SwTooltip from '../Common/SwTooltip/SwTooltip';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";
var FormData = require('form-data');
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

let options = [];
var cityOption = [];
var buildingOption = [];

function removeDuplicateRoomnames(arr) {
  const uniqueRoomnames = [];
  const seenRoomnames = new Set();

  for (const room of arr) {
    if (!seenRoomnames.has(room.roomname)) {
      seenRoomnames.add(room.roomname);
      uniqueRoomnames.push(room);
    }
  }

  return uniqueRoomnames;
}
class RoomBookingFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      required: {
        cityName: true,
        buildingName: false,
      },
      locationData: [],
      locationSpoc: [],

      rooms: [],
      selectedRoom: null,

      cityApiData: [],
      refreshCity: null,
      userid: UserObj ? UserObj.rec_id : null,
      refreshBuilding: null,
      buildingApiData: [],
      buildingOptions: [], // For the building dropdown
      floorOptions: [], // For the floor dropdown
      selectedBuilding: null, // Selected building object
      selectedFloor: null,
      selectedBuildingId: null, // Selected building object
      selectedFloorId: null,
      cityId: '', // Holds the selected City ID
      buildingId: '', // Holds the selected Building ID
      floorId: '', // Holds the selected Floor ID
      cityOptions: [], // List of City options for the dropdown
      buildingOptions: [], // List of Building options for the dropdown
      floorOptions: [],
      refreshroom: null,
      RoomList: [],
      roomexternal: [],
      company_id: UserObj ? UserObj.company_id : null,
      rtype: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
      category: '',

      rname: '',
      uname: '',
      phone: '',
      status: '',
      center: '',
      date: '',
      building_id: '',
      location: '',
      startDate: '',
      endDate: '',
    };
  }
  // reload = e => {
  //   const params = {

  //     pgno: this.props.namePg,
  //   };
  //   this.props.onSelectLanguage(params);
  //   this.props.RoomBookingData(params);
  //   this.setState({
  //     rtype: '',
  //     category: '',
  //     refreshroom: null,
  //     rname: '',
  //     phone: '',
  //     uname: '',
  //     date: '',
  //     status: '',
  //     refreshCity: '',
  //     refreshBuilding: null,
  //     location: '',
  //     startDate: '',
  //     endDate: '',
  //   });
  //   window.location.reload();
  // };

  /* Clears every filter field, drops the applied filters on the parent so
     pagination stops sending them, and reloads the unfiltered list. */
  resetFilter = () => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    this.setState({
      rtype: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
      category: '',
      rname: '',
      uname: '',
      phone: '',
      status: '',
      center: '',
      date: '',
      location: '',
      startDate: '',
      endDate: '',
      selectedRoom: null,
      selectedBuilding: null,
      selectedFloor: null,
      selectedBuildingId: null,
      selectedFloorId: null,
      refreshroom: null,
      refreshCity: null,
      refreshBuilding: null,
    });

    const params = {
      clientId: newCompanyId.organizationId,
      pgno: 1,
      row: this.props.row,
      propertyId: this.state.locationSpoc.map(item => item.newId),
      type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
    };

    this.props.RoomBookingData(params);
    this.props.onSelectLanguage({});
  };

  handleChange = selectedRoom => {
    this.setState({ selectedRoom });
  };
  handleChange1 = uname => {
    this.setState({ uname: uname.value });
  };
  handleChange2 = phone => {
    this.setState({ phone: phone.value });
  };
  handleChange3 = center => {
    this.setState({ center: center.value });
  };
  // handleChange4 = location => {
  //   this.setState({ location: location.value });
  // };

  changeSelect = e => {
    let { name, value } = e.target;

    // Convert "true"/"false" strings to actual boolean values
    if (name === 'category') {
      value = value === 'true' ? true : value === 'false' ? false : value;
    }

    this.setState({
      [name]: value, // Update the specific field
      location: value, // Assuming location should also be updated
    });
  };

  fetchBuildingData = async () => {
    let organizationId = JSON.parse(localStorage.getItem('headData'));

    try {
      const requestData = {
        ids: [organizationId.organizationId], // List of organization IDs you want to query
        includes: ['properties'], // Any other related properties (e.g., cities)
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/organizations/all`,
        requestData,
      );

      // Extract building options
      const buildingOptions = response?.data?.data[0]?.properties?.map(
        property => ({
          value: property.id,
          label: property.name, // Building name
          properties: property, // Attach the property object to later fetch floors
        }),
      );

      // Set the building options in the state
      this.setState({ buildingOptions });
    } catch (error) {
      console.error('Error fetching buildings:', error);
    }
  };

  // Handle building change (populate floor options based on the selected building)
  handleBuildingChange = selectedBuilding => {
    const { buildingOptions } = this.state;

    // Find the selected building from the building options
    const building = buildingOptions.find(
      building => building.value === selectedBuilding.value,
    );

    if (building) {
      // Extract the floors for the selected building
      const floorOptions =
        building.properties?.floors?.map(floor => ({
          value: floor.id,
          label: floor.name, // Floor name
        })) || [];

      // Set the selected building and floor options
      this.setState({
        selectedBuilding: selectedBuilding,
        selectedBuildingId: selectedBuilding.properties.id, // Store the full building object
        floorOptions, // Set floor options
        selectedFloor: null, // Reset the selected floor
      });
    }
  };

  submitFilter = e => {
    e.preventDefault();
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    const { startDate, endDate } = this.state;

    const startDateTime = startDate
      ? moment
        .tz(startDate, 'YYYY-MM-DD', 'Asia/Kolkata')
        .startOf('day')
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      : null;

    const endDateTime = endDate
      ? moment
        .tz(endDate, 'YYYY-MM-DD', 'Asia/Kolkata')
        .endOf('day')
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      : null;

    const baseParam = {
      type: this.state.rtype,
      row: this.props.row,
      pgno: this.props.namePg,
      propertyId: this.state.selectedBuildingId
        ? [this.state.selectedBuildingId]
        : this.state.locationSpoc.map(item => item.newId),
      clientId: newCompanyId.organizationId,
    };

    // ✅ Check explicitly for an empty string
    if (
      this.state.category !== '' &&
      this.state.category !== undefined &&
      this.state.category !== null
    ) {
      baseParam.resourceCategory = this.state.category;
    }

    if (this.state.uname) baseParam.userName = this.state.uname;
    if (startDateTime) baseParam.startDate = startDateTime;
    if (endDateTime) baseParam.endDate = endDateTime;
    if (this.state.status) baseParam.status = this.state.status;
    if (this.state.selectedRoom?.value)
      baseParam.resourceId = this.state.selectedRoom.value;

    const filteredParam = Object.fromEntries(
      Object.entries(baseParam).filter(
        ([_, value]) => value !== null && value !== undefined,
      ),
    );

    this.props.RoomBookingData(filteredParam);
    this.props.onSelectLanguage(filteredParam);
    this.props.onClose();
  };

  setuserlist = () => {
    const formData = new FormData();
    formData.append('company_id', this.state.company_id);
    const param = {
      company_id: this.state.company_id,
    };
    this.props.RoomPhoneData(param);
    //this.props.RoomBookingData(formData)
  };

  async componentDidMount() {
    try {
      this.setuserlist();
      // this.SetCityValue();
      await this.loadLocationAndRooms();
      this.locationValue();
      this.fetchBuildingData();
    } catch (error) {
      console.error('Error in componentDidMount async process:', error);
    }
  }

  loadLocationAndRooms = async () => {
    try {
      const locationSpoc = await this.fetchLocationData();
      if (locationSpoc.length > 0) {
        await this.fetchRooms(locationSpoc);
      }
    } catch (error) {
      console.error('Error in loadLocationAndRooms:', error);
    }
  };

  fetchLocationData = async () => {
    try {
      const authToken = JSON.parse(localStorage.getItem('headData'));
      const axiosConfig = {
        params: {
          spoc: UserObj.rec_id,
          client: this.state.company_id,
        },
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      };

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/basic-data/get-location-by-spoc`,
        axiosConfig,
      );

      const locationSpoc =
        response.data.status === 'success' ? response.data.data || [] : [];
      this.setState({ locationSpoc });
      return locationSpoc;
    } catch (error) {
      console.error('Error fetching location data:', error);
      this.setState({ locationSpoc: [] });
      return [];
    }
  };

  fetchRooms = async locationSpoc => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }meeting-room/api/resource/filter/all`,
        {
          type: [
            'Meeting Room',
            'Conference Room',
            'Training Room',
            'AV Lounge',
          ],
          propertyId: locationSpoc.map(item => item.newId),
          clientId: [newCompanyId.organizationId],
          reqFrom: 'cspoc',
        },
      );

      const rooms = response?.data?.data?.list.map(room => ({
        value: room._id,
        label: room.name,
      }));

      this.setState({ rooms });
    } catch (error) {
      console.error('Error fetching rooms:', error);
    }
  };

  // fetchCities = async () => {
  //   try {
  //     // Replace with your actual API endpoint for cities
  //     const response = await axiosInstance.get(`${process.env.REACT_APP_API_GATEWAYS_URL}core/cities/all`, {

  //     });

  //     const cities = response?.data?.data?.map(city => ({
  //       value: city.id,
  //       label: city.name,
  //     }));

  //     this.setState({ cityOptions: cities });
  //   } catch (error) {
  //     console.error('Error fetching cities:', error);
  //   }
  // };

  // Function to handle City change
  handleCityChange = async selectedCity => {
    this.setState({
      cityId: selectedCity.value,
      buildingId: '',
      floorId: '',
      buildingOptions: [],
      floorOptions: [],
    });

    // Call the Building API based on selected city ID
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/properties/city/${selectedCity.value
        }`,
      );

      const buildings = response.data.data.map(building => ({
        value: building.id,
        label: building.name,
      }));

      this.setState({ buildingOptions: buildings });
    } catch (error) {
      console.error('Error fetching buildings:', error);
    }
  };

  // Function to handle Building change

  locationValue = () => {
    const formData = {
      company_id: this.state.company_id,
      // token: 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==',
    };
    this.props.LocationFilterAction(formData);
  };

  /*1---setCity---*/
  SetCityValue = city => {
    let params = {
      company_id: this.state.company_id,
    };
    this.props.CityFilterAction(params);
  };
  /*1---setCity---*/
  /*2---getCityDAta---*/
  // CityNameMethod = city => {
  //   var required = this.state.required;
  //   required.buildingName = true;
  //   this.setState({
  //     city: city.value,
  //     refreshCity: city,
  //     required: required,
  //   });
  //   let params = {
  //     company_id: this.state.company_id,
  //     cityid: city.value,
  //   };
  //   this.props.buildingFilterAction(params);
  // };

  handleChange4 = city => {
    var required = this.state.required;
    required.buildingName = true;
    this.setState({
      city: city?.value,
      refreshCity: city,
      required: required,
    });
    let parm = {
      spoc: this.state.userid,
      client: this.state.company_id,
      city: city?.value,
    };

    // this.setState({ city: city.value, refreshCity: city });
    // this.props.onCityLocation1(parm);
    this.props.onBuildingLocation1(parm);
    this.state.refreshBuilding = null;
  };

  /*2---getCityDAta---*/
  /*3---Building---*/
  // buildingNameMethod = building => {
  //   var required = this.state.required;
  //   required.buildingName = false;
  //   this.setState({
  //     building_id: building.value,
  //     refreshBuilding: building,
  //     required: required,
  //   });
  //   let params = {
  //     company_id: this.state.company_id,
  //     buildingid: building.value,
  //   };
  // };
  handleChange5 = buildingid => {
    var required = this.state.required;
    required.buildingName = false;
    this.setState({
      buildingid: buildingid.value,
      refreshBuilding: buildingid,
      required: required,
    });
    let parm = {
      buildingid: buildingid.value,
      location: LocationObj,
    };
    this.setState({ building: buildingid.value, refreshBuilding: buildingid });
    // this.props.onBuildingLocation(parm);
    this.getDepDataByLocation(buildingid.value);
  };
  /*3---Building---*/

  componentWillReceiveProps(props) {
    if (props.CityNameReducer && props.CityNameReducer.length != 0) {
      this.setState({
        cityApiData: props.CityNameReducer,
      });
    }
    if (props.BuildingReducer && props.BuildingReducer.length != 0) {
      this.setState({
        buildingApiData: props.BuildingReducer,
        setFlagCity: true,
      });
    }
    if (props.LocationList && props.LocationList.status == 200) {
      this.setState({
        locationData:
          props.LocationList &&
          props.LocationList.data &&
          props.LocationList.data.data,
      });
    }

    if (
      props.roomReducer.RoomtList &&
      props.roomReducer.RoomtList.status == 200
    ) {
      let roomNames = [];
      let roomNamesList = removeDuplicateRoomnames(
        props.roomReducer.RoomtList.data.data.list,
      );

      roomNamesList.map((items, i) => {
        roomNames.push({
          value: items.resourceName,
          label: items.resourceName,
        });
      });
      if (!localStorage.getItem('roomNames')) {
        localStorage.setItem('roomNames', JSON.stringify(roomNames));
      }
      this.setState({
        RoomList:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data &&
          props.roomReducer.RoomtList.data.data.list,
        roomexternal: props.roomReducer.RoomPhoneData,
        opt: JSON.parse(localStorage.getItem('roomNames'))
          ? JSON.parse(localStorage.getItem('roomNames'))
          : roomNames,
      });
    }
  }

  RoomTypemethod = room => {
    // Ensure room is an array (for multi-select dropdowns)
    const selectedRoomTypes = Array.isArray(room)
      ? room.map(item => item.label)
      : [room.label];

    this.setState({ rtype: selectedRoomTypes, isRoomTypeTouched: true, });
  };

  RoomStatusMethod = status => {
    this.setState({ status: status.value });
  };

  render() {
    const {
      buildingOptions,
      floorOptions,
      selectedBuilding,
      selectedFloor,
    } = this.state;

    const roomList = JSON.parse(localStorage.getItem('roomNames'));

    const NewCity = this.props.CityData1.CityData1;

    const BuildingData = this.props.CityData1.BuildingData1;
    const options4 = [];

    if (NewCity !== 0) {
      NewCity &&
        NewCity.map((items, i) => {
          options4.push({ value: items.city_id, label: items.city_name });
        });
    }
    const options5 = [];
    if (BuildingData !== 0) {
      BuildingData &&
        BuildingData.map((items, i) => {
          options5.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }
    const roomType = [
      {
        value: 1,
        label: 'Meeting Room',
      },
      {
        value: 2,
        label: 'Conference Room',
      },
      {
        value: 3,
        label: 'Training Room',
      },
      {
        value: 4,
        label: 'Lounge Room',
      },
    ];

    const roomStatus = [
      {
        value: 'Booked',
        label: 'Booked',
      },
      {
        value: 'CheckIn',
        label: 'CheckIn',
      },
      {
        value: 'Completed',
        label: 'Completed',
      },
      {
        value: 'Cancelled',
        label: 'Cancelled',
      },
      {
        value: 'Extended',
        label: 'Extended',
      },
    ];

    //const roomexternal = this.props.roomReducer.RoomPhoneData;

    //--City--///

    // if (this.state.cityApiData !== 0) {
    //   this.state.cityApiData &&
    //     this.state.cityApiData.map((items, i) => {
    //       cityOption.push({ value: items.city_id, label: items.city_name });
    //     });
    // }

    if (this.state.cityApiData !== 0) {
      cityOption = [];
      this.state.cityApiData &&
        this.state.cityApiData.map((items, i) => {
          cityOption.push({ value: items.city_id, label: items.city_name });
        });
    }
    //--City---///
    //--Building---///

    // if (this.state.buildingApiData !== 0) {
    //   this.state.buildingApiData &&
    //     this.state.buildingApiData.map((items, i) => {
    //       buildingOption.push({
    //         value: items.building_id,
    //         label: items.building_name,
    //       });
    //     });
    // }
    if (this.state.buildingApiData !== 0) {
      buildingOption = [];
      this.state.buildingApiData &&
        this.state.buildingApiData.map((items, i) => {
          buildingOption.push({
            value: items.building_id,
            label: items.building_name,
          });
        });
    }
    //--Building--///

    //--name---///

    //--name---///

    //--name---///
    const options1 = [];
    if (this.state.RoomList?.length !== 0) {
      this.state.RoomList &&
        this.state.RoomList.map((items, i) => {
          options1.push({ value: items.first_name, label: items.first_name });
        });
    }
    //--name---///
    const options2 = [];
    if (this.state.roomexternal !== 0) {
      this.state.roomexternal &&
        this.state.roomexternal.nameandphone &&
        this.state.roomexternal.nameandphone.map((items, i) => {
          options2.push({ value: items.phone, label: items.phone });
        });
    }

    const options3 = [];
    if (this.state.RoomList !== 0) {
      this.state.RoomList &&
        this.state.RoomList.map((items, i) => {
          options3.push({
            value: items.building_name,
            label: items.building_name,
          });
        });
    }
    const categoryOptions = [
      { value: true, label: 'Shared' },
      { value: false, label: 'Private' },
    ];
    const selectedRoomTypeOptions = roomType.filter(opt =>
      this.state.rtype.includes(opt.label),
    );
    const selectedStatusOption = roomStatus.find(
      opt => opt.value === this.state.status,
    );
    return (
      <>
        <SwOffCanvas
          show={this.props.show}
          onClose={this.props.onClose}
          title="Filters"
          footer={
            <>
              <div className="OffCanvasFooter_Btns">
                <SwButton
                  type="button"
                  size="md"
                  variant="dark-outline"
                  onClick={this.resetFilter}
                >
                  Reset
                </SwButton>

                {this.state.required.buildingName ? (
                  <SwButton disabled size="md" onClick={this.submitFilter}>
                    Apply
                  </SwButton>
                ) : (
                  <SwButton size="md" onClick={this.submitFilter}>
                    Apply
                  </SwButton>
                )}
                {/* <button
                          className="btn btn-success addDetails ml10"
                          onClick={this.submitFilter}
                        >
                          Apply
                        </button> */}
              </div>
            </>
          }
        >
          <form>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Room Category</label>
                  <SwSelect
                    id="RBCategory"
                    options={categoryOptions}
                    placeholder="Select Room category"
                    value={categoryOptions.find(
                      opt => opt.value === this.state.category,
                    )}
                    isClearable={false}
                    onChange={selectedOption => {
                      this.setState({
                        category: selectedOption ? selectedOption.value : '',
                      });
                    }}
                  />
                </div>

                <div className="SwFormGroup">
                  <label className="SwFormLabel">Room Type</label>
                  <SwSelect
                    id="RBRoomType"
                    name="rtype"
                    onChange={this.RoomTypemethod}
                    options={roomType}
                    placeholder="Select Room type"
                    isClearable={false}
                    value={this.state.isRoomTypeTouched
                      ? selectedRoomTypeOptions
                      : null}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Room Name</label>
                  <SwSelect
                    id="RBRoomName"
                    placeholder="Select Room name"
                    value={this.state.selectedRoom}
                    onChange={this.handleChange}
                    options={this.state.rooms}
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">User Name </label>
                  <SwInput
                    id="RBUserName"
                    placeholder="Enter User name"
                    type="text"
                    onChange={this.changeSelect}
                    name="uname"
                    value={this.state.uname}
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">
                    Building Name<span className="Required">*</span>
                    <SwTooltip
                      placement="top"
                      content={
                        <>
                          Please select Building Name
                        </>
                      }
                    >
                      <span role="button" className="ms-2">
                        <i class="bi bi-info-circle" />
                      </span>
                    </SwTooltip>
                  </label>
                  <SwSelect
                    id="RBBuildingName"
                    placeholder="Select Building name"
                    isClearable={false}
                    onChange={this.handleBuildingChange}
                    options={buildingOptions}
                    value={selectedBuilding || null}
                  />
                  {this.state.required.buildingName ? (
                    <span className="SwTextDanger SwTextSmall">
                      Please select building name
                    </span>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Start Date</label>
                  <AntDDatePicker
                    type="single"
                    name="startDate"
                    format="DD/MM/YYYY"
                    value={
                      this.state.startDate
                        ? dayjs(this.state.startDate, "YYYY-MM-DD")
                        : null
                    }
                    onChange={(date) =>
                      this.setState({
                        startDate: date ? date.format("YYYY-MM-DD") : "",
                        endDate: "",
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">End Date</label>
                  <AntDDatePicker
                    type="single"
                    name="endDate"
                    format="DD/MM/YYYY"
                    value={
                      this.state.endDate
                        ? dayjs(this.state.endDate, "YYYY-MM-DD")
                        : null
                    }
                    disabled={!this.state.startDate}
                    disabledDate={(current) =>
                      this.state.startDate
                        ? current && current < dayjs(this.state.startDate, "YYYY-MM-DD")
                        : false
                    }
                    onChange={(date) =>
                      this.setState({
                        endDate: date ? date.format("YYYY-MM-DD") : "",
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Status </label>
                  <SwSelect
                    id="RBStatus"
                    placeholder="Select Status"
                    name="status"
                    onChange={this.RoomStatusMethod}
                    options={roomStatus}
                    value={selectedStatusOption || null}
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
          </form>
        </SwOffCanvas>

        <SwIconButton size='sm'
          onClick={this.props.onOpen}
        >
          <i className="bi bi-funnel" />
        </SwIconButton>
      </>
    );
  }
}

const mapStateToProps = state => ({
  roomReducer: state.roomReducer,
  CityNameReducer: state.roomTraingReducer.TrainingRoomCityData,
  BuildingReducer: state.roomTraingReducer.TrainingRoomBuilding,
  LocationList: state.seatReducer.LocationFilterList,
  CityData1: state.activeUserList,
  BuildingData: state.activeUserList,
});

const mapActionsToProps = {
  RoomBookingData,
  RoomPhoneData,
  CityFilterAction,
  buildingFilterAction,
  LocationFilterAction,
  onBuildingLocation1,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomBookingFilter);
